module.exports = __webpack_public_path__ + "static/img/contact_title2.36b987a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/contact_title2.png
// module id = rVRL
// module chunks = 4